import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import {
  theme,
  IconPositiveResults
} from '@contrast-security-inc/design-system-foundations'
import { InformationPanel } from '@contrast-security-inc/design-system-surfaces'
import { Stack } from '@contrast-security-inc/design-system-layouts'

export const OverviewTabEmptyState = () => {
  const intl = useIntl()

  return (
    <Stack>
      <InformationPanel
        className={css`
          width: 100%;
          height: fit-content;
          border: 1px solid ${theme.color.neutral40};
          box-shadow: none;
        `}
        Icon={IconPositiveResults}
        IconProps={{
          testId: 'library-usage-grid-thumbs-up-icon'
        }}
        title={intl.formatMessage({
          id: 'title_libraryUsage_library_secure'
        })}
        subtitle={intl.formatMessage({
          id: 'description_libraryUsage_library_secure'
        })}
      />
    </Stack>
  )
}
